import React, { useEffect, useState, useRef } from "react";
import fetch from "node-fetch";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useParams } from "react-router-dom";
import "./index.css";
import { API_URL, CONF } from "../config";
import ReCAPTCHA from "react-google-recaptcha";

const initialFormState = {
  posterId: "",
  title: "",
  authors: "",
  topic: "",
  session: "",
  file: "",
  fileName: "",
  recordingFile: "",
  recordingFileName: "",

  authorFullName: "",
  authorEmail: "test@altasoft.pl",
  authorFacebook: "",
  authorSkype: "",

  fullName: "",
  email: "test@altasoft.pl",
  phone: "",

  gdprConsent: false,
  postersConsent: false,
  posterIdInvalid: false,
  posterIdValidationMessage: "",
  fileValid: false,
  validationMessage: "",
  recordingFileInvalid: false,
  recordingFileValidationMessage: "",

  failure: false,
  isSending: false,
  sent: false,
};

const NewApplication = () => {
  const { posterId } = useParams();
  const recaptchaRef = useRef(null);
  const [formState, setFormState] = useState(initialFormState);

  useEffect(() => {
    const getApplicationDetails = async () => {
      try {
        const result = await fetch(`${API_URL}/new-application/${posterId}?conf=${CONF}`);
        const details = await result.json();

        setFormState({
          ...details,
        });
      } catch (e) {
        console.log(e);
      }
    };

    posterId && getApplicationDetails();
  }, [posterId]);

  const handleSubmit = async (event) => {
    event.persist();
    event.preventDefault();
    event.stopPropagation();

    const data = new FormData();

    const {
      title,
      authors,
      file,
      fileName,
      recordingFile,
      recordingFileName,
      consent,
      posterId,
      topic,
      authorFullName,
      authorEmail,
      authorFacebook,
      authorSkype,
      fullName,
      email,
      phone,
      gdprConsent,
      postersConsent,
    } = formState;

    let recaptchaCode = recaptchaRef.current.getValue();

    data.append("title", title);
    data.append("authors", authors);
    data.append("fileName", fileName.replaceAll(" ", ""));
    data.append("recordingFileName", recordingFileName.replaceAll(" ", ""));
    data.append("file", file);
    data.append("recordingFile", recordingFile);
    data.append("consent", consent);
    data.append("posterId", posterId);
    data.append("topic", topic);
    data.append("authorFullName", authorFullName);
    data.append("authorEmail", authorEmail);
    data.append("authorFacebook", authorFacebook);
    data.append("authorSkype", authorSkype);
    data.append("fullName", fullName);
    data.append("email", email);
    data.append("phone", phone);
    data.append("gdprConsent", gdprConsent);
    data.append("postersConsent", postersConsent);
    data.append("recaptcha", recaptchaCode);

    setFormState((f) => ({
      ...f,
      isSending: true,
    }));

    const response = await fetch(`${API_URL}/new-application/v2/?conf=${CONF}`, {
      method: "POST",
      body: data,
    });

    if (response.status === 201) {
      setFormState({
        ...initialFormState,
        isSending: false,
        sent: true,
      });
    } else {
      setFormState({
        ...formState,
        isSending: false,
        failure: true,
      });
    }
  };

  const handleTextInputChange = (event) => {
    event.persist();

    setFormState({
      ...formState,
      [event.target.name]: event.target.value,
    });
  };

  // const handleRecordingFileChange = (event) => {
  //   event.persist();
  //   if (
  //     ![
  //       "audio/mpeg",
  //       "video/mp4"
  //     ].includes(event.target.files[0].type)
  //   ) {
  //     setFormState({
  //       ...formState,
  //       recordingFileInvalid: true,
  //       recordingFileValidationMessage: "Obsługiwane typy plików to: mp3 i mp4.",
  //     });
  //     return;
  //   }

  //   if (event.target.files[0].size > 5e7) {
  //     setFormState({
  //       ...formState,
  //       recordingFileInvalid: true,
  //       recordingFileValidationMessage: "Maksymalny rozmiar pliku to 10MB.",
  //     });
  //     return;
  //   }

  //   setFormState({
  //     ...formState,
  //     recordingFileInvalid: false,
  //     recordingFile: event.target.files[0],
  //     recordingFileName: event.target.files[0].name,
  //   });
  // };

  const handleFileChange = (event) => {
    event.persist();
    if (
      ![
        "application/pdf",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "image/jpg",
        "image/jpeg"
      ].includes(event.target.files[0].type)
    ) {
      setFormState({
        ...formState,
        fileInvalid: true,
        validationMessage: "Supported file types are: jpeg, pptx, ppt and pdf.",
      });
      return;
    }

    if (event.target.files[0].size > 5e7) {
      setFormState({
        ...formState,
        fileInvalid: true,
        validationMessage: "Maximum file size is 10MB.",
      });
      return;
    }

    setFormState({
      ...formState,
      fileInvalid: false,
      file: event.target.files[0],
      fileName: event.target.files[0].name,
    });
  };

  useEffect(() => {
    const loadData = async () => {
      const posterDataResponse = await fetch(
        `${API_URL}/new-application/${formState.posterId}?conf=${CONF}`,
        {}
      );

      if (posterDataResponse.status === 200) {
        const posterData = await posterDataResponse.json();
        setFormState((f) => ({ ...f, ...posterData, posterIdInvalid: false }));
      } else if (posterDataResponse.status === 404) {
        setFormState((f) => ({
          ...initialFormState,
          posterId: f.posterId,
          posterIdInvalid: true,
          posterIdValidationMessage: "Abstract with the provided code does not exist.",
        }));
      } else if (posterDataResponse.status === 409) {
        setFormState((f) => ({
          ...initialFormState,
          posterId: f.posterId,
          posterIdInvalid: true,
          posterIdValidationMessage:
            "Abstract with this number has already been placed on the Platform. If you want to change the abstract – contact the Organizational Office – you will receive a new code.",
        }));
      } else {
        setFormState((f) => ({
          ...initialFormState,
          posterId: f.posterId,
          posterIdInvalid: true,
          posterIdValidationMessage: "Invalid code entered"
        }));
      }
    };

    if (formState.posterId.length === 2) {
      loadData();
    }
  }, [formState.posterId]);

  if (formState.sent) {
    return (
      <div className="new-application-container ">
        <div className="form-title">
          <h1>Application has been accepted.</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="new-application-container ">
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="posterId">
          <Form.Label>Abstract code*</Form.Label>
          <Form.Control
            isInvalid={formState.posterIdInvalid}
            name="posterId"
            onChange={handleTextInputChange}
            value={formState.posterId}
            type="text"
            placeholder="Abstract code"
          />
          <Form.Control.Feedback
            style={{
              display: formState.posterIdInvalid ? "block" : "none",
            }}
            type="invalid"
          >
            {formState.posterIdValidationMessage}
          </Form.Control.Feedback>
          <Form.Text className="text-muted">
            Provide the abstract code according to the table in the announcement of accepted
            abstracts:{" "}
            <a
              href="https://dermatologiagdansk.pl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://dermatologiagdansk.pl/
            </a>
            .
          </Form.Text>
        </Form.Group>
        <Form.Group controlId="title">
          <Form.Label>Title*</Form.Label>
          <Form.Control
            as="textarea"
            rows={Math.floor(formState.title.length / 90) + 1}
            name="title"
            value={formState.title}
            disabled
            type="text"
            placeholder="e.g. Extended research on the latest discovery in medicine"
          />
        </Form.Group>
        <Form.Group controlId="authors">
          <Form.Label>Authors*</Form.Label>
          <Form.Control
            name="authors"
            as="textarea"
            rows={Math.floor(formState.authors.length / 90) + 1}
            value={formState.authors}
            disabled
            type="text"
            placeholder="e.g. John Smith, Jane Doe, Bob Johnson"
          />
        </Form.Group>
        <Form.Group controlId="topic">
          <Form.Label>Topic*</Form.Label>
          <Form.Control
            name="topic"
            value={formState.topic}
            disabled
            type="text"
          />
        </Form.Group>
        <Form.Group controlId="session">
          <Form.Label>Session*</Form.Label>
          <Form.Control
            name="session"
            value={formState.session}
            disabled
            type="text"
          />
        </Form.Group>
        <Form.Group controlId="presentationFile">
          <Form.Label>Presentation file*</Form.Label>
          <Form.File
            isInvalid={formState.fileInvalid}
            required
            onChange={handleFileChange}
            id="custom-file"
            label={`${formState.fileName || "e.g. Presentation.pptx"}`}
            custom
          />
          <Form.Text className="text-muted">
            Supported file types are: jpeg, pptx, ppt and pdf.
          </Form.Text>
          <Form.Control.Feedback
            style={{
              display: formState.fileInvalid ? "block" : "none",
            }}
            type="invalid"
          >
            {formState.validationMessage}
          </Form.Control.Feedback>
        </Form.Group>
        <h4>
          Provide contact details of the author with whom interested persons can
          contact regarding the presented work.
        </h4>
        <Form.Group controlId="authorFullName">
          <Form.Label>Title, first name, last name*</Form.Label>
          <Form.Control
            name="authorFullName"
            onChange={handleTextInputChange}
            value={formState.authorFullName}
            type="text"
            placeholder="e.g. Dr. John Smith"
          />
        </Form.Group>
        <Form.Group controlId="authorEmail">
          <Form.Label>Email address*</Form.Label>
          <Form.Control
            name="authorEmail"
            onChange={handleTextInputChange}
            value={formState.authorEmail}
            type="text"
            placeholder="np. michal.polonczyk@gmail.com"
          />
        </Form.Group>
        <Form.Group controlId="authorFacebook">
          <Form.Label>Facebook</Form.Label>
          <Form.Control
            name="authorFacebook"
            onChange={handleTextInputChange}
            value={formState.authorFacebook}
            type="text"
            placeholder="np. facebook.com/michal.lukasz111"
          />
        </Form.Group>
        <Form.Group controlId="authorSkype">
          <Form.Label>Skype</Form.Label>
          <Form.Control
            name="authorSkype"
            onChange={handleTextInputChange}
            value={formState.authorSkype}
            type="text"
            placeholder="np. michal.lukasz111"
          />
        </Form.Group>
        <h4>Provide your contact details.</h4>
        <Form.Group controlId="fullName">
          <Form.Label>First name, last name*</Form.Label>
          <Form.Control
            name="fullName"
            onChange={handleTextInputChange}
            value={formState.fullName}
            type="text"
            placeholder="e.g. John Smith"
          />
        </Form.Group>
        <Form.Group controlId="email">
          <Form.Label>Email address*</Form.Label>
          <Form.Control
            name="email"
            onChange={handleTextInputChange}
            value={formState.email}
            type="text"
            placeholder="np. michal.polonczyk@gmail.com"
          />
        </Form.Group>
        <Form.Group controlId="phone">
          <Form.Label>Phone*</Form.Label>
          <Form.Control
            name="phone"
            onChange={handleTextInputChange}
            value={formState.phone}
            type="text"
            placeholder="e.g. +1 555 123 456"
          />
        </Form.Group>

        <Form.Group controlId="gdprConsent">
          <Form.Text className="text-muted">
            I declare that I have familiarized myself with{" "}
            <a
              href="https://dermatologiagdansk.pl/dokumenty/BFDWiA-RODO.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Information Clause regarding Personal Data Processing
            </a>{" "}
            and{" "}
            <a
              href="https://altasoft.pl/p_private_policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              AltaSoft Privacy Policy
            </a>{" "}
            regulating the processing of my personal data by
            AltaSoft sp. z o.o.*
          </Form.Text>
          <Form.Check
            value={formState.gdprConsent}
            onChange={(event) => {
              setFormState({
                ...formState,
                gdprConsent: event.target.checked,
              });
            }}
            type="checkbox"
            label="I give consent"
            feedback="Giving this consent is a necessary condition for participation in the competition"
          />
        </Form.Group>
        <Form.Group controlId="postersConsent">
          <Form.Text className="text-muted">
            I consent to the processing of my personal data contained in
            the submitted application for the purposes necessary for the presentation of the abstract
            during the 15th International PTA Congress by AltaSoft sp. z o.o.*
          </Form.Text>
          <Form.Check
            value={formState.postersConsent}
            onChange={(event) => {
              setFormState({
                ...formState,
                postersConsent: event.target.checked,
              });
            }}
            type="checkbox"
            feedback="Giving this consent is a necessary condition for participation in the competition"
            label="I give consent"
          />
          <Form.Text className="text-muted">
            The administrator of your personal data is AltaSoft sp. z o.o. (hereinafter AltaSoft) with its registered office at ul.
            Pukowca 15, 40-847 Katowice, tel. +48 322598399/98/96, KRS: 0000558517, REGON: 361525651, NIP: 634-28-39-789 Providing data is
            voluntary, however it is necessary to place the abstract in the Congress Participant Zone and further for its presentation during the Congress. You have the right to access
            your personal data, correct it and request its deletion (including
            the right to be forgotten) by contacting the Conference Service Office
            AltaSoft (address as above) or by email to
            konferencje@altasoft.pl. Every person whose data is concerned has the right
            to lodge a complaint with the supervisory authority if they believe that
            the processing of personal data concerning them violates applicable
            regulations. Your data is processed until consent is withdrawn
            for its processing or until the completion or cessation by
            AltaSoft of the purpose of its processing. AltaSoft takes
            all appropriate security measures in accordance with currently
            applicable legal regulations, as well as commonly accepted
            principles serving to protect the confidentiality of information, in particular with
            Regulation of the European Parliament and Council (EU) 2016/679 of
            April 27, 2016.
          </Form.Text>
          <Form.Text className="text-muted">
            * fields marked with an asterisk are required.
          </Form.Text>
        </Form.Group>
        <div className="form-submit">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6Ld6QMMaAAAAAIAY9tDFWw7B_m_LNlSFENwp7gnz"
          />
          <Button
            disabled={formState.posterIdInvalid || formState.isSending}
            variant="primary"
            type="submit"
          >
            {formState.isSending ? "Sending..." : "Send"}
          </Button>
          <Form.Control.Feedback
            style={{
              display: formState.failure ? "block" : "none",
            }}
            type="invalid"
          >
            Error sending form. Make sure the entered data is
            correct and try again. If the error persists,
            contact the Organizational Office.
          </Form.Control.Feedback>
        </div>
      </Form>
    </div>
  );
};

export default NewApplication;
